import $ from 'jquery';
import i18n from '../config/i18n';

export default function (actions) {
  $.ajaxSetup({
    statusCode: {
      401: () => {
        localStorage.clear();
        actions.createDangerAlert(i18n.t('tokenExpiredMsg'));

        setTimeout(() => {
          window.location = '/logout';
        }, 3000);
      },
    },
  });
}



// WEBPACK FOOTER //
// ./src/utils/handleAjax401Error.js